import { Component, Vue } from 'vue-property-decorator';

import IdentityService, { IdentityUser } from '@/services/identity';

@Component
export default class IdentityMixin extends Vue {
  get tempUser(): IdentityUser {
    return IdentityService.getTempUser();
  }

  get tempUserId() {
    return this.tempUser.id;
  }

  updateTempUserId(id: string) {
    IdentityService.updateTempId(id);
  }

  refreshIdentity() {
    IdentityService.refreshIdentity();
  }
}
